import { encoderChannel } from './encoder-channel';

export const storageProvider = {
  encoderChannel,
};
